module.exports = __webpack_public_path__ + "static/p13_back-988c55a8fc736f488fa9b77426bf8b3e.jpg";